import React from 'react';
import { useNavigate } from 'react-router';
import { CallbackComponent } from 'redux-oidc';

import { getUserManager } from '../../libs/auth';
import { LocalStorageManager } from '../../libs/utils';

const userManager = getUserManager();

const Callback = () => {
  const navigate = useNavigate();

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() => {
        const redirectTo = LocalStorageManager.getRedirectUrlOnReturn();
        LocalStorageManager.removeRedirectUrlOnReturn();
        let url = '/';

        // Clean up legacy AAD flag — no longer needed with Code flow
        localStorage.removeItem('aad');

        if (redirectTo != null) {
          url = redirectTo;
        }
        navigate(url, { replace: true });
      }}
      errorCallback={() => navigate('/', { replace: true })}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  );
};

export default Callback;
